import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useWorkTimeTypeSelect } from './useWorkTimeTypeSelect';

interface WorkTimeTypeSelectProps {
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the type list is only fetched where the field is rendered. It renders the
 * trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const WorkTimeTypeSelect = ({ onOpenPicker, onClear }: Readonly<WorkTimeTypeSelectProps>) => {
  const { t } = useTranslation();
  const select = useWorkTimeTypeSelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('worktime:workTimeType')}
      placeholder={t('worktime:selectWorkTimeType')}
      searchPlaceholder={t('worktime:searchWorkTimeTypes')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="workTimeType"
      data-testid="worktime-type-select-button"
    />
  );
};

export default WorkTimeTypeSelect;
